export const roles = {
    'Studente / Student': 'RL_stud',
    'Docente / Teacher': 'RL_prof',
    Funzionario: 'RL_funz',
    Anonimo: 'RL_anon',
    default: 'RL_anon'
};

export const resources = {
    '/myLibrary': 'RS000PF',
    '/zLibrary': 'RS000PF',
    '/search': 'RS000PF',
    default: 'RS000NN'
};
